import { createFeatureSelector, createSelector } from '@ngrx/store';
import * as fromOrganization from '../reducers/organization.reducer';

export const selectOrganizationState = createFeatureSelector<fromOrganization.State>(
  fromOrganization.organizationFeatureKey
);

export const selectCategoriesState = createSelector(
  selectOrganizationState,
  (state: fromOrganization.State) => state.categories
);

export const selectAreasState = createSelector(
  selectOrganizationState,
  (state: fromOrganization.State) => state.areas
);

export const selectCurrentItemState = createSelector(
  selectOrganizationState,
  (state: fromOrganization.State) => state.currentItem
);

export const selectInCat = createSelector(
  selectOrganizationState,
  (state: fromOrganization.State) => state.inCat
);

export const selectNotInCat = createSelector(
  selectOrganizationState,
  (state: fromOrganization.State) => state.notInCat
);

export const selectIsLoading = createSelector(
  selectOrganizationState,
  (state: fromOrganization.State) => state.isLoading
);

export const selectUncategorized = createSelector(
  selectOrganizationState,
  (state: fromOrganization.State) => state.uncategorized
);

export const selectNotInCatPos = createSelector(
  selectOrganizationState,
  (state: fromOrganization.State) => state.notInCatPos
);

export const selectInCatPos = createSelector(
  selectOrganizationState,
  (state: fromOrganization.State) => state.inCatPos
);

/* start multilocations selectors */
export const selectLocationState = createFeatureSelector<fromOrganization.State>(
  fromOrganization.organizationFeatureKey
);

export const selectCurrentPage = createSelector(
  selectLocationState,
  (state: fromOrganization.State) => state?.currentPage
);

export const DeleteLocationShowErrorMessage = createSelector(
  selectLocationState,
  (state) => state.error_message
);
/* start multilocations selectors */
